import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

import Swiper from 'swiper/bundle'; // import Swiper JS ALL

/*
 * Common
*/

// 旧記事対応

// 記事内のYouTube埋め込み比率を16:9を保持
document.addEventListener('DOMContentLoaded', function () {
  const iframes = document.querySelectorAll('.cms iframe');

  iframes.forEach(function (iframe) {
    const src = iframe.getAttribute('src');

    // YouTube iframe かつ、すでにラップされていない場合のみ処理
    if (src && src.includes('youtube.com') && !iframe.parentElement.classList.contains('ratio')) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('ratio-16x9');

      iframe.classList.add('ratioin');
      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);
    }
  });
});


// Single
const postSwiper = new Swiper('.post-swiper', {
  slidesPerView: 1,
  spaceBetween: 18,
  centeredSlides: false,
  /*
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  */
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 48,
      initialSlide: 1,
      centeredSlides: true,
    }
  }
});

// Hero
const heroSwiper = new Swiper('.hero-swiper', {
  spaceBetween: 30,
  loop: true,
  /*
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  */
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  speed: 800,
  autoplay: {
    delay: 4000, // 5000ミリ秒 = 5秒ごとにスライド
    disableOnInteraction: false, // ユーザー操作後も自動再生を継続
  },
});


/*
 * Single product
 */

/*
$(function() {
  //swiper 768以下で起動
  var swiper;
  $(window).on('load resize', function(){
    var w = $(window).width();
    if (w <= 767.98) {
      if (swiper) {
        return;
      } else {
        swiper = new Swiper('#single-product-gallery', {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiper) {
        swiper.destroy();
        swiper = undefined;
      }
    }
  });
});

const SingleProductSubgallerySwiper = new Swiper('#single-product-subgallery', {
  slidesPerView: "auto",
  spaceBetween: 18,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      slidesPerView: "auto",
      spaceBetween: 48,
    }
  }
});
*/

document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".product-gallery-swiper", {
    loop: true,
    /*
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    */
    spaceBetween: 0,
    slidesPerView: 1,
    breakpoints: {
      991: {
        spaceBetween: 10,
      }
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    speed: 800,
    autoplay: {
      delay: 4000, // 5000ミリ秒 = 5秒ごとにスライド
      disableOnInteraction: false, // ユーザー操作後も自動再生を継続
    },
  });
});


/*
 * WooCommerce: My Account
 */

document.addEventListener('DOMContentLoaded', function() {
  const nav = document.querySelector('.woocommerce-MyAccount-navigation');
  if (nav) {
    nav.addEventListener('click', function() {
      nav.classList.toggle('is-open');
    });
  }
});
